// Take from the mscan api endpoint TODO convert to live pull

export const rebateCategories = [
  { ID: 1, Name: 'Military', Subcategory: null },
  { ID: 2, Name: 'College Grad', Subcategory: null },
  { ID: 4, Name: 'Brand Loyalty', Subcategory: null },
  { ID: 5, Name: 'Conquest', Subcategory: null },
  { ID: 6, Name: 'First Responders', Subcategory: null },
  { ID: 7, Name: 'Partner Program', Subcategory: null },
  {
    ID: 3,
    Name: 'Membership',
    Subcategory: [
      { ID: 1, Name: 'USAA' },
      { ID: 2, Name: 'Farm Bureau' },
      { ID: 3, Name: 'Dairy Farmers Of America' },
      { ID: 4, Name: 'American Quarter Horse Association' },
      //{ ID: 5, Name: 'Mobility' }, // TODO ?
      { ID: 6, Name: 'Associated Builders & Contractors' },
      { ID: 7, Name: 'Associated General Contractors' },
      { ID: 8, Name: 'Future Farmers of America (FFA)' },
      { ID: 9, Name: 'National Association of Realtors' },
      { ID: 10, Name: 'National Association of Remodelers' },
      { ID: 11, Name: 'National Federation of Independent Buisnesses' },
      { ID: 12, Name: 'National Funeral Directors Association (NFDA)' },
      { ID: 13, Name: 'New Holland Equipment' },
      { ID: 14, Name: 'Plumbing Heating Cooling Contractors Association' },
      { ID: 15, Name: 'Snow & Ice Managements Association (SIMA)' },
      { ID: 16, Name: 'Case Construction Equip' },
      { ID: 17, Name: 'Police Association IUPA and NAPO' },
      { ID: 18, Name: 'United Auto Workers (UAW)' },
      { ID: 21, Name: 'Costco' },
    ],
  },
  {
    ID: 1000,
    Name: 'Info Purposes Only',
    Subcategory: [
      { ID: 19, Name: 'Pull Forward' },
      { ID: 20, Name: 'Mobility' },
    ],
  },
]

export default rebateCategories
